import { RECEIVE_VR_REPORT_ONGOING } from "../actions/vrReportOngoing";

const DEFAULT_STATE = {
  vrReportsOngoing: [],
};

const vrReportsOngoing = (state = DEFAULT_STATE, action: any) => {
  switch (action.type) {
    case RECEIVE_VR_REPORT_ONGOING: {
      return {
        vrReportsOngoing: action.vrReportsOngoing,
      };
    }
    default:
      return state;
  }
};

export default vrReportsOngoing;
